// App
import React from 'react';

// Misc / utils
import * as S from './styles';

type RadioButtonProps = {
  ariaLabel?: string;
  icon?: string;
  iconWidth?: string;
  iconHeight?: string;
  iconAriaAltText?: string;
  isChecked?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  name?: string;
  id?: string;
  children?: React.ReactNode;
  value?: string;
};

const RadioButton = React.forwardRef<HTMLInputElement, RadioButtonProps>(
  (
    {
      ariaLabel,
      icon,
      iconWidth = '12px',
      iconHeight = '12px',
      iconAriaAltText = '',
      isChecked = false,
      onChange,
      name,
      id,
      children,
      value,
      ...rest
    },
    ref,
  ) => (
    <S.Wrapper>
      <S.Input
        aria-label={ariaLabel}
        aria-checked={isChecked}
        type="radio"
        name={name}
        id={id}
        checked={isChecked}
        ref={ref}
        value={value}
        onChange={onChange}
        {...rest}
      />
      <S.Label htmlFor={id}>
        {icon && <S.Icon src={icon} width={iconWidth} height={iconHeight} alt={iconAriaAltText} />}
        {children}
      </S.Label>
    </S.Wrapper>
  ),
);

export default RadioButton;
